<template>
  <div class="px-4 pt-4">
    <v-row class="ma-0 py-1" align="center">
      <v-col cols="12" md="6" class="d-flex align-center py-1">
        <span class="text-h5">Contract Details</span>
      </v-col>

      <v-col cols="12" md="6" class="text-right py-1">
        <v-tooltip top v-if="contractDetails.status == 'Active' && permissions && permissions.add">
          <template #activator="{ on, attrs }">
            <v-btn icon v-on="on" v-bind="attrs" @click="showCloseRemarksForm = true">
              <v-icon color="error">mdi-alert-octagon</v-icon>
            </v-btn>
          </template>
          <span>Close Tariff</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-divider class="mb-3"></v-divider>

    <v-card outlined color="grey lighten-4" class="pa-3 mb-3">
      <v-row class="ma-0" dense>
        <v-col cols="6" md="2" class="py-1">
          <span class="text-caption grey--text">Contract ID</span>
          <p class="text-subtitle-1 font-weight-medium mb-0">
            {{ contractDetails.contract_id }}
          </p>
        </v-col>
        <v-col cols="6" md="3" class="py-1">
          <span class="text-caption grey--text">Vendor</span>
          <p class="text-subtitle-1 font-weight-medium mb-0">
            {{ contractDetails.customer_detail && contractDetails.customer_detail.company_name }}
          </p>
        </v-col>
        <v-col cols="6" md="2" class="py-1">
          <span class="text-caption grey--text">Start Date</span>
          <p class="text-subtitle-1 font-weight-medium mb-0">
            {{ $globals.formatDate(contractDetails.extra_info && contractDetails.extra_info.start_date) }}
          </p>
        </v-col>
        <v-col cols="6" md="2" class="py-1">
          <span class="text-caption grey--text">End Date</span>
          <p class="text-subtitle-1 font-weight-medium mb-0">
            {{ $globals.formatDate(contractDetails.extra_info && contractDetails.extra_info.end_date) }}
          </p>
        </v-col>
        <v-col cols="6" md="2" class="py-1">
          <span class="text-caption grey--text">Status</span>
          <p class="mb-0">
            <v-chip small :color="statusColor(contractDetails.status)" dark>
              {{ contractDetails.status }}
            </v-chip>
          </p>
        </v-col>

        <v-col cols="12" class="py-1">
          <v-divider></v-divider>
        </v-col>

        <v-col cols="6" md="2" class="py-1">
          <span class="text-caption grey--text">Created On</span>
          <p class="text-subtitle-1 font-weight-medium mb-0">
            {{ $globals.formatDate(contractDetails.extra_info && contractDetails.extra_info.created, true) }}
          </p>
        </v-col>
        <v-col cols="6" md="2" class="py-1">
          <span class="text-caption grey--text">Created By</span>
          <p class="text-subtitle-1 font-weight-medium mb-0">
            {{ contractDetails.extra_info && contractDetails.extra_info.created_by }}
          </p>
        </v-col>
        <v-col cols="6" md="4" class="py-1">
          <span class="text-caption grey--text">Remarks</span>
          <p class="text-subtitle-1 font-weight-medium mb-0">
            {{
              (contractDetails.remarks_detail &&
                contractDetails.remarks_detail.admin_remarks) ||
              "-"
            }}
          </p>
        </v-col>
      </v-row>
    </v-card>

    <v-tabs v-model="detailsTab" @change="resizeRateGrid(); resizeChargeGrid();">
      <v-tab>Contract Rates</v-tab>
      <v-tab>Contract Charges</v-tab>
    </v-tabs>
    <v-divider></v-divider>

    <v-tabs-items v-model="detailsTab">
      <v-tab-item class="pt-2">
        <v-row class="ma-0" align="center">
          <v-col cols="12" md="4">
            <v-text-field
              label="Search Route"
              outlined
              dense
              append-icon="mdi-magnify"
              clearable
              hide-details="auto"
              v-model="rateSearch"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="8" class="d-flex justify-end align-center">
            <v-btn
              v-if="permissions && permissions.add"
              color="primary"
              outlined
              depressed
              class="mr-2"
              @click="openAddRate"
            >
              <v-icon left>mdi-plus</v-icon>
              Add Rate
            </v-btn>
            <v-btn
              color="primary"
              outlined
              depressed
              class="mr-2"
              @click="exportRates"
            >
              <v-icon left>mdi-export</v-icon>
              Export Rates
            </v-btn>
            <v-btn
              v-if="permissions && permissions.add"
              color="primary"
              outlined
              depressed
              class="mr-2"
              @click="showBulkUploadDialog = true"
            >
              <v-icon left>mdi-upload</v-icon>
              Bulk Upload
            </v-btn>
            <v-btn
              color="primary"
              outlined
              depressed
              class="mr-3"
              @click="showLogsDialog = true"
            >
              <v-icon left>mdi-format-list-bulleted</v-icon>
              Logs
            </v-btn>
            <Pagination
              v-if="rateTotalCount > 0"
              :pageNo="ratePageNo"
              :totalItems="rateTotalCount"
              :pageSize="ratePageSize"
              @itemsPerPageChange="onRatePageSizeChange"
              @prevPage="onRatePrevPage"
              @nextPage="onRateNextPage"
            />
          </v-col>

          <v-col cols="12">
            <AgGridVue
              :style="{ width: '100%', height: rateGridHeight }"
              class="ag-theme-alpine"
              :columnDefs="rateHeaders"
              :context="context"
              :defaultColDef="defaultColDef"
              :rowData="rates"
              @grid-ready="onRateGridReady"
              @gridSizeChanged="resizeRateGrid"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item class="pt-3">
        <v-row class="ma-0" align="center">
          <v-col cols="12" class="d-flex justify-end align-center">
            <v-btn
              v-if="permissions && permissions.add"
              color="primary"
              outlined
              depressed
              class="mr-2"
              @click="openAddCharge"
            >
              <v-icon left>mdi-plus</v-icon>
              Add Charge
            </v-btn>
            <v-btn
              color="primary"
              outlined
              depressed
              class="mr-3"
              @click="showLogsDialog = true"
            >
              <v-icon left>mdi-format-list-bulleted</v-icon>
              Logs
            </v-btn>
            <Pagination
              v-if="chargeTotalCount > 0"
              :pageNo="chargePageNo"
              :totalItems="chargeTotalCount"
              :pageSize="chargePageSize"
              @itemsPerPageChange="onChargePageSizeChange"
              @prevPage="onChargePrevPage"
              @nextPage="onChargeNextPage"
            />
          </v-col>

          <v-col cols="12">
            <AgGridVue
              :style="{ width: '100%', height: chargeGridHeight }"
              class="ag-theme-alpine"
              :columnDefs="chargeHeaders"
              :context="context"
              :defaultColDef="defaultColDef"
              :rowData="charges"
              @grid-ready="onChargeGridReady"
              @gridSizeChanged="resizeChargeGrid"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="showLogsDialog" width="600">
      <v-card>
        <v-card-title class="secondary white--text">
          Contract Logs
          <v-spacer></v-spacer>
          <v-btn icon @click="showLogsDialog = false">
            <v-icon class="white--text">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-sheet
            style="height: 400px; overflow-y: auto; overflow-x: hidden"
          >
            <v-timeline v-if="logs && logs.length" class="px-0" align-top dense>
              <v-timeline-item
                v-for="(log, index) in logs"
                :key="index"
                color="primary"
                icon="mdi-circle"
                small
              >
                <v-row class="pt-1">
                  <v-col>
                    <strong>{{ log.created | formatDate(true) }}</strong>
                    <div class="text-body-2">{{ log.message }}</div>
                    <div class="text-caption">- {{ log.updated_by }}</div>
                  </v-col>
                </v-row>
              </v-timeline-item>
            </v-timeline>
            <div v-else>No Logs to show</div>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>

    <CustomerContractV2RateDialog
      v-model="showRateDialog"
      :contractId="contractId"
      :editRate="selectedRate"
      @submitted="onRateSubmitted"
    />

    <CustomerContractV2ChargeDialog
      v-model="showChargeDialog"
      :contractId="contractId"
      :editCharge="selectedCharge"
      @submitted="onChargeSubmitted"
    />

    <CustomerContractV2RateBulkUploadDialog
      v-model="showBulkUploadDialog"
      :contractId="contractId"
      @submitted="onBulkUploadSubmitted"
    />

    <RejectionRemarksDialog
      v-model="showCloseRemarksForm"
      :formDetails="closeDetails"
      :isRequiredRemarks="true"
      fieldKey="close_remarks"
      label="Close Remarks"
      @submitRemarks="closeContract"
    />
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import CustomerContractV2RateDialog from "@/components/ModuleBased/dialogForms/CustomerContractV2RateDialog.vue";
import CustomerContractV2ChargeDialog from "@/components/ModuleBased/dialogForms/CustomerContractV2ChargeDialog.vue";
import CustomerContractV2RateBulkUploadDialog from "@/components/ModuleBased/dialogForms/CustomerContractV2RateBulkUploadDialog.vue";
import RejectionRemarksDialog from "@/components/ModuleBased/dialogs/RejectionRemarksDialog.vue";
import CustomerContractV2RateButton from "@/components/AgGridComponents/CustomerContractV2RateButton.vue";
import CustomerContractV2ChargeButton from "@/components/AgGridComponents/CustomerContractV2ChargeButton.vue";
import Pagination from "@/components/General/Pagination.vue";

export default {
  components: {
    AgGridVue,
    Pagination,
    CustomerContractV2RateDialog,
    CustomerContractV2ChargeDialog,
    CustomerContractV2RateBulkUploadDialog,
    RejectionRemarksDialog,
    CustomerContractV2RateButton,
    CustomerContractV2ChargeButton,
  },
  props: {
    contractId: {
      type: Number,
    },
    permissions: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    contractId(val) {
      this.resetData();
      this.getCustomerContractV2Details();
      this.getRates();
      this.getCharges();
      this.getLogs();
    },
    rateSearch() {
      if (this.rateSearchTimeout) {
        clearTimeout(this.rateSearchTimeout);
      }
      this.rateSearchTimeout = setTimeout(() => {
        this.ratePageNo = 1;
        this.getRates();
      }, 400);
    },
  },
  data() {
    return {
      contractDetails: {},
      rates: [],
      charges: [],
      logs: [],
      detailsTab: 0,
      rateSearch: "",
      ratePageNo: 1,
      ratePageSize: 20,
      rateTotalCount: 0,
      chargePageNo: 1,
      chargePageSize: 20,
      chargeTotalCount: 0,
      showRateDialog: false,
      selectedRate: {},
      showChargeDialog: false,
      selectedCharge: {},
      showLogsDialog: false,
      showBulkUploadDialog: false,
      showCloseRemarksForm: false,
      closeDetails: {},
      gridApi: null,
      chargeGridApi: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        flex: 1,
      },
      rateHeaders: [
        { headerName: "Route", field: "lane_title", minWidth: 130, flex: 1.4 },
        { headerName: "Job Type", field: "job_type", minWidth: 90, flex: 1 },
        { headerName: "Product", field: "container_type_title", minWidth: 90, flex: 1 },
        { headerName: "Count", field: "container_count", minWidth: 70, flex: 0.6 },
        {
          headerName: "Rate",
          field: "rate",
          minWidth: 90,
          flex: 0.8,
          valueFormatter: (params) => Number(params.value).toFixed(2),
        },
        {
          headerName: "Updated On",
          field: "modified",
          minWidth: 110,
          flex: 1.1,
          valueFormatter: (params) => this.$globals.formatDate(params.value, true),
        },
        { headerName: "Updated By", field: "updated_by", minWidth: 110, flex: 1 },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 70,
          maxWidth: 70,
          flex: 0,
          sortable: false,
          cellRendererFramework: "CustomerContractV2RateButton",
        },
      ],
      chargeHeaders: [
        { headerName: "Charge", field: "charge_title", minWidth: 130, flex: 1.4 },
        { headerName: "Description", field: "description", minWidth: 150, flex: 1.6 },
        { headerName: "GL No.", field: "gl_no", minWidth: 90, flex: 1 },
        { headerName: "Charge Type", field: "da_charge_type", minWidth: 100, flex: 1 },
        { headerName: "Tax %", field: "tax_percentage", minWidth: 70, flex: 0.6 },
        {
          headerName: "Tax",
          field: "tax",
          minWidth: 80,
          flex: 0.7,
          valueFormatter: (params) => Number(params.value).toFixed(2),
        },
        {
          headerName: "Rate",
          field: "rate",
          minWidth: 90,
          flex: 0.8,
          valueFormatter: (params) => Number(params.value).toFixed(2),
        },
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          minWidth: 70,
          maxWidth: 70,
          flex: 0,
          sortable: false,
          cellRendererFramework: "CustomerContractV2ChargeButton",
        },
      ],
    };
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    rateGridHeight() {
      return this.gridHeightFor(this.rates.length);
    },
    chargeGridHeight() {
      return this.gridHeightFor(this.charges.length);
    },
  },
  methods: {
    onRatePageSizeChange(size) {
      this.ratePageSize = size;
      this.ratePageNo = 1;
      this.getRates();
    },
    onRatePrevPage() {
      this.ratePageNo--;
      this.getRates();
    },
    onRateNextPage() {
      this.ratePageNo++;
      this.getRates();
    },
    onChargePageSizeChange(size) {
      this.chargePageSize = size;
      this.chargePageNo = 1;
      this.getCharges();
    },
    onChargePrevPage() {
      this.chargePageNo--;
      this.getCharges();
    },
    onChargeNextPage() {
      this.chargePageNo++;
      this.getCharges();
    },
    statusColor(status) {
      const colors = {
        Active: "success",
        Pending: "warning",
        Rejected: "error",
        Closed: "grey",
      };
      return colors[status] || "grey";
    },
    gridHeightFor(rowCount) {
      const headerHeight = 45;
      const rowHeight = 42;
      const paginationHeight = 56;
      const minHeight = 145;
      const maxHeight = 450;
      const visibleRows = Math.min(rowCount || 0, 20) || 1;
      const height = headerHeight + visibleRows * rowHeight + paginationHeight;
      return `${Math.min(Math.max(height, minHeight), maxHeight)}px`;
    },
    resetData() {
      this.contractDetails = {};
      this.rates = [];
      this.charges = [];
      this.logs = [];
      this.detailsTab = 0;
      this.rateSearch = "";
      this.ratePageNo = 1;
      this.rateTotalCount = 0;
      this.chargePageNo = 1;
      this.chargeTotalCount = 0;
    },
    getCustomerContractV2Details() {
      this.$bus.$emit("showLoader", true);
      this.$api.customerContractV2
        .getCustomerContractV2Details(this.contractId)
        .then((res) => {
          this.contractDetails = { ...res.data, id: this.contractId };
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    getRates() {
      this.$bus.$emit("showLoader", true);
      this.$api.customerContractV2
        .getCustomerContractV2RateList({
          customer_contract_v2: this.contractId,
          search: this.rateSearch,
          limit: this.ratePageSize,
          offset: (this.ratePageNo - 1) * this.ratePageSize,
        })
        .then((res) => {
          this.rates = res.data;
          this.rateTotalCount = "count" in res ? res.count : res.data.length;
          this.$bus.$emit("showLoader", false);
          this.$nextTick(() => {
            this.resizeRateGrid();
          });
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    getLogs(params = {}) {
      params = {
        ...params,
        customer_contract_v2: this.contractId,
        limit: "50",
        offset: 0,
      };
      this.$api.customerContractV2
        .getCustomerContractV2ActivityLogs(params)
        .then((res) => {
          this.logs = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getCharges() {
      this.$bus.$emit("showLoader", true);
      this.$api.customerContractV2
        .getCustomerContractV2Charges({
          customer_contract_v2: this.contractId,
          limit: this.chargePageSize,
          offset: (this.chargePageNo - 1) * this.chargePageSize,
        })
        .then((res) => {
          this.charges = res.data;
          this.chargeTotalCount = "count" in res ? res.count : res.data.length;
          this.$bus.$emit("showLoader", false);
          this.$nextTick(() => {
            this.resizeChargeGrid();
          });
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    onRateGridReady(params) {
      this.gridApi = params.api;
      this.resizeRateGrid();
    },
    resizeRateGrid() {
      if (this.gridApi) {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 100);
      }
    },
    onChargeGridReady(params) {
      this.chargeGridApi = params.api;
      this.resizeChargeGrid();
    },
    resizeChargeGrid() {
      if (this.chargeGridApi) {
        setTimeout(() => {
          this.chargeGridApi.sizeColumnsToFit();
        }, 100);
      }
    },
    openAddRate() {
      this.selectedRate = {};
      this.showRateDialog = true;
    },
    exportRates() {
      this.$bus.$emit("showLoader", true);
      this.$api.customerContractV2
        .exportCustomerContractV2Rates(this.contractId)
        .then((response) => {
          this.$bus.$emit("showLoader", false);
          const blob = response.data;
          const downloadLink = window.document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(
            new Blob([blob], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          downloadLink.download = `${this.contractDetails.contract_id || "contract"}_rates.xlsx`;
          downloadLink.click();
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't export Rates!",
            color: "error",
          });
          this.$bus.$emit("showLoader", false);
        });
    },
    openEditRate(rate) {
      this.selectedRate = { ...rate };
      this.showRateDialog = true;
    },
    onRateSubmitted() {
      this.getRates();
      this.getLogs();
    },
    openAddCharge() {
      this.selectedCharge = {};
      this.showChargeDialog = true;
    },
    openEditCharge(charge) {
      this.selectedCharge = { ...charge };
      this.showChargeDialog = true;
    },
    onChargeSubmitted() {
      this.getCharges();
      this.getLogs();
    },
    onBulkUploadSubmitted() {
      this.getRates();
      this.getLogs();
    },
    closeContract() {
      this.$bus.$emit("showLoader", true);
      const payload = {
        id: this.contractId,
        close_remarks: this.closeDetails.close_remarks,
      };
      this.$api.customerContractV2
        .closeCustomerContractV2(payload)
        .then(() => {
          this.$bus.$emit("showToastMessage", {
            message: "Tariff closed successfully!",
            color: "success",
          });
          this.showCloseRemarksForm = false;
          this.getCustomerContractV2Details();
          this.$emit("refreshList");
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.$bus.$emit("showToastMessage", {
            message: `${
              err.data && err.data.non_field_errors
                ? err.data.non_field_errors.join()
                : "Tariff cant be closed"
            }`,
            color: "error",
          });
          this.$bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    this.resetData();
    this.getCustomerContractV2Details();
    this.getRates();
    this.getCharges();
    this.getLogs();
  },
};
</script>
